import { Box } from '@mui/material'
import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  AppDispatch, FederalActions, GrantsSelectors,
  RootState,
  SmallBusinessSelectors,
  SmallBusinessSliceActions,
} from '../../../../store'
import { FormsSelector } from '../../../../store/forms'
import { SearchForm } from '../SearchForm'
import { SmallBusinessAndFederalList } from '../SearchResults'
import { Paging } from './Paging'

export const SmallBusiness: FC = () => {
  const dispatch = useDispatch<AppDispatch>()

  const formId = 'sbir'
  const formValues = useSelector((state: RootState) => FormsSelector.getFormValues(state, formId))

  const { value = '' } = formValues

  const loading = useSelector(SmallBusinessSelectors.getLoading)
  const grants = useSelector(SmallBusinessSelectors.makeSmallBusinessGrants)

  const agencies = useSelector(SmallBusinessSelectors.getSelectedAgencies)
  const phases = useSelector(SmallBusinessSelectors.getSelectedPhases)
  const statuses = useSelector(SmallBusinessSelectors.getSelectedStatuses)
  const startDate = useSelector(SmallBusinessSelectors.getStartDate)
  const endDate = useSelector(SmallBusinessSelectors.getEndDate)

  const handleFiltersChange = (filters:any) => {
    dispatch(SmallBusinessSliceActions.setFilters(filters))
  }

  const handleSearch = (value: string, limit: number = 25, skip: number = 0) => {
    if (!value) return

    const options = {
      params: {
        query: value,
        $limit: limit,
        $skip: skip,
        $sort: 'score desc',
        $includes: 'solicitation,agency',
      },
    }

    const isoStartDate = startDate && startDate.format().split('T')[0] + 'T00:00:00Z'
    const isoEndDate = endDate && endDate.format().split('T')[0] + 'T00:00:00Z'

    const payload = {
      agencies,
      phases,
      statuses,
      startDate: isoStartDate,
      endDate: isoEndDate,
    }

    dispatch(SmallBusinessSliceActions.fetchSmallBusinessGrantsAsync({payload, options }))
  }

  return (
    <Box>
      <SearchForm
        filters={{
          agencies,
          statuses,
          phases,
          deadline: {
            startDate,
            endDate
          }
        }}
        formId={formId}
        loading={loading}
        handleFiltersChange={handleFiltersChange}
        onSearch={() => {
          dispatch(SmallBusinessSliceActions.resetPaging());
          handleSearch(value)
        }}
        heading= 'Small business'
        subHeading='SBIR/STTR grants are designed for small businesses pursuing new innovations or products. These grants provide non-dilutive funding to support research and development activities that have potential for commercialization.'
      />

      <SmallBusinessAndFederalList result={grants} />

      {grants && !!grants.length && (
        <Paging cb={(limit:number, skip:number) => handleSearch(value, limit, skip)} />
      )}
    </Box>
  )
}
